import { TrackRecordItemModel } from '@_types/organisms';
import Picture from '@atoms/pictures/Picture';
import { getModifiers } from '@helpers/functions';
import { Fragment } from 'react/jsx-runtime';

type AnchorProps = {
  href?: string;
  className?: string;
  children: React.ReactNode;
};

function Anchor(props: AnchorProps) {
  const { children, ...rest } = props;

  return props.href ? (
    <a {...rest} className={`${props.className} kf-a-link kf-a-link--no-underline`}>
      {children}
    </a>
  ) : (
    <div {...rest}>{children}</div>
  );
}

export default function TrackRecordItem(model: Readonly<TrackRecordItemModel>) {
  const { image, header, subHeader, tableRows, tableTitle, contactList, detailsRichText } = model;
  const styleModifier = getModifiers(model, 'kf-o-track-record-item');

  return (
    <div className={styleModifier}>
      <div className="kf-o-track-record-item__image">
        <Picture {...image} />
      </div>
      <div className="kf-o-track-record-item__content">
        <div className="kf-o-track-record-item__header-area">
          {subHeader && <div className="kf-o-track-record-item__sub-header title">{subHeader}</div>}
          <h4 className="kf-o-track-record-item__header">{header}</h4>
          <Separator />
        </div>
        <div className="kf-o-track-record-item__content-detail">
          <div className="kf-o-track-record-item__table-area">
            <div className="kf-o-track-record-item__table-title title">{tableTitle}</div>
            <div className="kf-o-track-record-item__content-scrollable">
              <div className="kf-o-track-record-item__table">
                {tableRows.map((row) => (
                  <Fragment key={row.value}>
                    <div className="kf-o-track-record-item__table__row-title">{row.title}</div>
                    <div>{row.value}</div>
                  </Fragment>
                ))}
              </div>
              {detailsRichText && (
                <div
                  dangerouslySetInnerHTML={{ __html: detailsRichText }}
                  className="kf-o-track-record-item__details kf-rich-text-box"
                  data-theme="white"
                />
              )}
            </div>
          </div>

          {contactList && (
            <div className="kf-o-track-record-item__contact-area">
              <Separator />
              <div className="kf-o-track-record-item__contact-area__title title">{contactList?.title}</div>

              <div className="kf-o-track-record-item__contact-area__list">
                {contactList?.contacts.map((contact) => (
                  <Anchor key={contact.name} className="kf-o-track-record-item__contact" href={contact.url}>
                    <div className="kf-o-track-record-item__contact__image">
                      <Picture {...contact.image} />
                    </div>
                    <div>
                      <h5 className="kf-o-track-record-item__contact__name">{contact.name}</h5>
                      {contact.jobTitle && <p className="kf-o-track-record-item__contact__job-title">{contact.jobTitle}</p>}
                    </div>
                  </Anchor>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Separator() {
  return <div className="kf-o-track-record-item__separator" />;
}
